import { useEffect, useState } from "react";
import { setApiErrorHandlerNewAppVersionCallback } from "../../../api/RestClient/apiErrorHandler";
import NewAppVersionDialog from "./NewAppVersionDialog/NewAppVersionDialog";

const NewAppVersion = () => {
    const [showDialog, setShowDialog] = useState(false);

    useEffect(() => {
        setApiErrorHandlerNewAppVersionCallback(() => setShowDialog(true));
        return () => setApiErrorHandlerNewAppVersionCallback(undefined);
    }, []);

    return showDialog && <NewAppVersionDialog />;
};

export default NewAppVersion;
